import React from 'react';
import { Tooltip, withStyles } from '@material-ui/core';

// ---------------- Helpers ---------------- //

export const CustomTooltip = withStyles(() => ({
    tooltip: {
        fontSize: '12px',
        maxWidth: '600px',
        background: '#1b1b1b',
        borderRadius: 0,
        color: '#fff',
        padding: '4px 9px',
        lineHeight: 1,
        cursor: 'pointer'
    },
    tooltipPlacementTop: {
        margin: '0 0 1px !important',
    },
}))(Tooltip);


export const formatEvents = (schedules: any[]) => {
  return schedules.flatMap((item) => {
    const startDate = item.startDate.replace(/z|Z/g, '');
    const endDate = item.endDate.replace(/z|Z/g, '');
    const start = new Date(startDate);
    const end = new Date(endDate);
    const title = item.title ?? '';

    const baseEvent = {
      ...item,
      startDate,
      endDate,
      start,
      end,
      id: item.idSchedule,
      title
    };

    const mode = item.studentScheduleMode || "ALL_TIME";
    let events: any[] = [];

    // ======================================================
    // ===============  MODO ALL_TIME  ======================

    if (mode === "ALL_TIME") {

      const isMultiDay = start.toDateString() !== end.toDateString();

      // Multi-dia → segmenta tudo (primeiro, meio, último)
      if (isMultiDay) {
        const startClean: any = new Date(start);
        startClean.setHours(0, 0, 0, 0);

        const endClean: any = new Date(end);
        endClean.setHours(0, 0, 0, 0);

        const totalDays =
          Math.round((endClean - startClean) / (1000 * 60 * 60 * 24)) + 1;

        for (let i = 0; i < totalDays; i++) {
          const dayStart = new Date(startClean);
          dayStart.setDate(startClean.getDate() + i);
          dayStart.setHours(0, 0, 0, 0);

          const dayEnd = new Date(dayStart);
          dayEnd.setHours(23, 59, 59, 999);

          events.push({
            ...baseEvent,
            start: dayStart,
            end: dayEnd,
            allDay: true,
            segmentPosition:
              i === 0 ? "first" : i === totalDays - 1 ? "last" : "middle"
          });
        }
      } else {
          // Apenas um dia
        if (!item.idEnrollment) {
          events.push({
            ...baseEvent,
            start,
            end,
            allDay: false,
            segmentPosition: "first"
          });
        } else {
          const dayStart = new Date(start);
          dayStart.setHours(0, 0, 0, 0);

          const dayEnd = new Date(end);
          dayEnd.setHours(23, 59, 59, 999);
          
          events.push({
            ...baseEvent,
            start: dayStart,
            end: dayEnd,
            allDay: true,
            segmentPosition: "first"
          });
        }
      }

      // Meetings
      if (item.meetings && item.meetings.length > 0) {
        const { meetings, startDate, finishDate, ...rest } = item;

        const meetingEvents = meetings.map((meeting: any, index: number) => {
          const meetingStart = new Date(meeting.startDate);
          const meetingEnd = new Date(meeting.finishDate);
          
          // console.log('meeting', item);
          const meetingTitle = meeting.title
              ? meeting.title
              : meeting.meetingRecurrence && meeting.meetingRecurrence.title
              ? meeting.meetingRecurrence.title
              : `Encontro ${index + 1}`;
          
          return {
            ...rest,
            ...meeting,
            start: meetingStart,
            end: meetingEnd,
            endDate: meeting.finishDate,
            id: meeting.idMeeting,
            type: "Meeting",
            title: `${meetingTitle} - ${title}`,
            meetingRecurrence: meeting.meetingRecurrence || null
          };
        });

        events = events.concat(meetingEvents);
      }

      return events;
    }

    // ======================================================
    // ===============  MODO EXACT_DAYS =====================

    const isMultiDay = start.toDateString() !== end.toDateString();

    // --- 1) SCHEDULE START ---
    if (isMultiDay) {
      const firstDayStart = new Date(start);
      firstDayStart.setHours(0, 0, 0, 0);
      const firstDayEnd = new Date(start);
      firstDayEnd.setHours(23, 59, 59, 999);

      events.push({
        ...baseEvent,
        start: firstDayStart,
        end: firstDayEnd,
        allDay: true,
        type: "ScheduleStart"
      });
    }

    // --- 2) MEETINGS ---
    let meetingEvents: any[] = [];

    if (item.meetings && item.meetings.length > 0) {
      const { meetings, startDate, finishDate, ...rest } = item;

      meetingEvents = meetings.map((meeting: any, index: number) => {
        const meetingStart = new Date(meeting.startDate);
        const meetingEnd = new Date(meeting.finishDate);
        // console.log('meeting', item);
        const meetingTitle = meeting.title
            ? meeting.title
            : meeting.meetingRecurrence && meeting.meetingRecurrence.title
            ? meeting.meetingRecurrence.title
            : `Encontro ${index + 1}`;

        return {
          ...rest,
          ...meeting,
          start: meetingStart,
          end: meetingEnd,
          endDate: meeting.finishDate,
          id: meeting.idMeeting,
          type: "Meeting",
          title: `${meetingTitle} - ${title}`,
          meetingRecurrence: meeting.meetingRecurrence || null
        };
      });
    }

    // --- 3) SCHEDULE END ---
    if (isMultiDay) {
      const lastDayStart = new Date(end);
      lastDayStart.setHours(0, 0, 0, 0);
      const lastDayEnd = new Date(end);
      lastDayEnd.setHours(23, 59, 59, 999);

      events.push({
        ...baseEvent,
        start: lastDayStart,
        end: lastDayEnd,
        allDay: true,
        type: "ScheduleEnd"
      });
    }

    // --- Evento de um dia ---
    if (!isMultiDay) {
      events = [baseEvent, ...meetingEvents];
      return events;
    }

    // Insere meetings ao final
    events = events.concat(meetingEvents);

    return events;
  });
};






export const sortEvents = (events) => {
    return [...events].sort((a, b) => {
        const startA:any = new Date(a.start);
        const startB:any = new Date(b.start);

        if (startA.toDateString() !== startB.toDateString()) {
            return startA - startB;
        }
        if (startA.getTime() !== startB.getTime()) {
            return startA.getTime() - startB.getTime();
        }
        return (a.title || '').localeCompare(b.title || '');
    });
}

export const TRAINING_OPTIONS = [
    {
        description: 'Assíncrono',
        idScheduleType: 'ASYNCHRONOUS',
    },
    {
        description: 'Blended',
        idScheduleType: 'BLENDED',
    },
];

export const formatDate = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
});

export const formatDateOnly = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
});

//daq 

export const capitalizeFirst = (value) => {
    if (!value && value !== 0) return value;
    const str = String(value);
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatDateRange = (start, end) => {
    try {
        const s = new Date(start);
        const f = new Date(end);

        const date = s.toLocaleDateString('pt-BR');

        const optionsTime: Intl.DateTimeFormatOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        };

        const startTime = s.toLocaleTimeString('pt-BR', optionsTime);
        const endTime = f.toLocaleTimeString('pt-BR', optionsTime);

        return `${date} das ${startTime}h às ${endTime}h`;
    } catch (e) {
        return '';
    }
};



export const renderSpeaker = (speaker) => {
    return (
        <>{`Condutor: ${capitalizeFirst(
            speaker,
        )}`}</>
    );
};

export const isMeetingEvent = (contentModal: any = {}) => contentModal.type === 'Meeting';

export const renderAddress = (address, meetingType) => {
    return (
        <span className="renderAddress">
            {meetingType === 'ONLINE' ? (
                <>
                    <a href={address} target="_blank" rel="noopener noreferrer">
                        Entrar na reunião
                    </a>
                </>
            ) : (
                <>Endereço: {address}</>
            )}
        </span>
    );
};


export const formatMeetingRecurrence = (recurrence, startDate) => {
    try {
        const { finishDate, interval = 1, type, weekDays } = recurrence;

        if (!finishDate) return '';

        const finish = new Date(finishDate);
        const start = new Date(startDate);

        const formattedFinishDate = finish.toLocaleDateString('pt-BR');

        switch (type?.toUpperCase()) {
            case 'DAILY':
                if (interval === 1) {
                    return `Todos os dias até ${formattedFinishDate}.`;
                }

                return `A cada ${interval} dias até ${formattedFinishDate}.`;

            case 'WEEKLY': {
                const weekdayNames = [
                    'domingo',
                    'segunda-feira',
                    'terça-feira',
                    'quarta-feira',
                    'quinta-feira',
                    'sexta-feira',
                    'sábado',
                ];
                const weekdays = Array.isArray(weekDays)
                    ? weekDays
                        .filter((day) => Number.isInteger(day) && day >= 0 && day <= 6)
                        .map((day) => weekdayNames[day])
                    : [];
                const weekday = weekdays.length > 0
                    ? weekdays.join(', ')
                    : start.toLocaleDateString('pt-BR', { weekday: 'long' });
                const prefix = /^(domingo|sábado)/.test(weekday) ? 'Todo' : 'Toda';

                if (interval === 1) {
                    return `${prefix} ${weekday} a cada semana até ${formattedFinishDate}.`;
                }

                return `${prefix} ${weekday} a cada ${interval} semanas até ${formattedFinishDate}.`;
            }

            case 'MONTHLY': {
                const day = start.getDate();

                if (interval === 1) {
                    return `Dia ${day} de cada mês até ${formattedFinishDate}.`;
                }

                return `Todo dia ${day} a cada ${interval} meses até ${formattedFinishDate}.`;
            }

            default:
                return '';
        }
    } catch (error) {
        return '';
    }
};

export const filterMeetingRecurrences = (meetings: any[] = []) => {
    const seenRecurrences = new Set();

    return meetings.filter((item) => {
        // Evento sem recorrência: mantém sempre
        if (item.meetingRecurrence === null) {
            return true;
        }

        const recurrenceId = item.idMeetingRecurrence;

        // Já apareceu essa recorrência: remove
        if (seenRecurrences.has(recurrenceId)) {
            return false;
        }

        // Primeira ocorrência: guarda e mantém
        seenRecurrences.add(recurrenceId);

        return true;
    });
};

export const getMeetingCarried = (contentModal: any = {}) => {
    if (!contentModal?.finishDate) return false;

    const now = new Date();
    const finishDate = new Date(contentModal.finishDate);

    return now > finishDate;
};

export const getMeetingRecurrences = (contentModal: any = {}) => {
    return filterMeetingRecurrences(contentModal.meetings || []);
};
